import { create } from 'zustand';

export interface SuperUserSession {
  id: number;
  email: string;
  name: string;
}

interface AuthState {
  user: SuperUserSession | null;
  /** Token temporário do fluxo de TOTP (setup ou challenge). */
  pendingToken: string | null;
  pendingTokenScope: 'totp_setup' | 'totp_challenge' | null;
  /** Boot inicial: tentando restaurar sessão via cookie. */
  bootstrapping: boolean;
  setUser: (user: SuperUserSession | null) => void;
  setPendingToken: (token: string | null, scope?: 'totp_setup' | 'totp_challenge') => void;
  setBootstrapping: (b: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  pendingToken: null,
  pendingTokenScope: null,
  bootstrapping: true,
  setUser: (user) => set({ user }),
  setPendingToken: (token, scope) =>
    set({ pendingToken: token, pendingTokenScope: token ? scope ?? null : null }),
  setBootstrapping: (b) => set({ bootstrapping: b }),
  clear: () => set({ user: null, pendingToken: null, pendingTokenScope: null }),
}));
